import { PROGRAMS_COLLECTION } from 'constants/firebase';
import { db } from 'services/firebase';
import { FetchResponse } from 'models';
import Mapper from 'data/Mapper';
import DataBase from '.';

class Programs extends DataBase {
  getAllBySubscriptionType<T>(
    isSubscriptionRequired: boolean,
  ): Promise<FetchResponse<T[]>> {
    return db
      .collection(this.collection)
      .where('isSubscriptionRequired', '==', isSubscriptionRequired)
      .orderBy('order', 'asc')
      .get()
      .then((snapshot) => {
        const data: T[] = [];
        snapshot.forEach((doc) =>
          data.push(({ ...doc.data(), id: doc.id } as unknown) as T),
        );
        return Mapper.mapSuccesResponse(data);
      })
      .catch((error) => {
        return Mapper.mapError(error);
      });
  }

  getAllFromOrder<T>(
    order: number,
    isSubscriptionRequired: boolean,
  ): Promise<FetchResponse<T[]>> {
    return db
      .collection(this.collection)
      .where('isSubscriptionRequired', '==', isSubscriptionRequired)
      .where('order', '>=', order)
      .orderBy('order', 'asc')
      .get()
      .then((snapshot) => {
        const data: T[] = [];
        snapshot.forEach((doc) =>
          data.push(({ ...doc.data(), id: doc.id } as unknown) as T),
        );
        return Mapper.mapSuccesResponse(data);
      })
      .catch((error) => {
        return Mapper.mapError(error);
      });
  }

  getOrders<T>(isSubscriptionRequired: boolean): Promise<FetchResponse<T[]>> {
    return db
      .collection(this.collection)
      .where('isSubscriptionRequired', '==', isSubscriptionRequired)
      .orderBy('order', 'asc')
      .get()
      .then((snapshot) => {
        const data: T[] = [];
        snapshot.forEach((doc) => data.push(doc.data().order));
        return Mapper.mapSuccesResponse(data);
      })
      .catch((error) => {
        return Mapper.mapError(error);
      });
  }
}

export default new Programs(PROGRAMS_COLLECTION);
